import * as React from 'react';

import { cn } from '../lib/utils.ts';

// Mark geometry lifted from docs/design/brand/embent-mark-clean.svg (the master). Two paths,
// not one: the bowl carries its counter as an evenodd hole, and the speech-bubble tail is a
// separate overlapping shape — subpaths of a single evenodd path would XOR the overlap into a
// hole instead of uniting. Tail widened and tile padding cut to 13% on 2026-08-06 (Johnny: the
// old tail was unreadable small and the tile had too much air).
//
// Composed inside a 512x512 tile from the mark's own tight box (x259.04 y265.34, 498.65 square):
// 13% padding per side leaves 74% of the tile, so scale = 512*0.74/498.65 = 0.7598, and the
// translate centers that box: (512 - 498.65*0.7598)/2 / 0.7598 - 259.04 = -170.35 on x,
// likewise -176.65 on y.
const MARK_BODY =
  'M515.63 269.238C528.556 269.121 541.471 270.032 554.252 271.963C616.911 281.86 673.103 316.16 710.546 367.367C743.795 411.813 760.472 466.479 757.694 521.915C757.178 532.079 755.827 541.291 754.293 551.342C743.028 550.612 728.2 551.027 716.572 551.033L649.252 551.064L475.032 551.019C447.69 551.001 420.181 551.441 392.88 550.982C397.462 574.7 417.195 602.624 435.731 617.884C463.04 640.368 497.51 652.346 532.916 649.079C564.136 646.187 593.306 632.274 615.2 609.833C620.502 604.449 624.32 599.178 629.114 593.416C632.927 596.732 647.425 605.826 652.133 608.932L691.577 635.01C699.002 639.879 708.293 645.583 715.354 650.756C711.571 656.334 706.363 662.713 702.142 667.982C666.858 712.426 610.962 743.52 554.842 751.487C491.965 760.411 428.127 743.883 377.48 705.568A240 240 0 0 1 324.231 651.765C295.892 614.705 280.041 564.129 278.854 517.728C277.533 452.988 301.955 390.369 346.759 343.618C391.882 296.149 450.46 270.93 515.63 269.238Z M508.761 373.203C511.826 372.786 516.827 372.83 519.967 372.852C572.39 373.22 627.787 410.038 641.151 462.132C603.85 462.002 566.55 462.068 529.25 462.329L444.771 462.185C429.106 462.124 411.109 462.444 395.712 461.496C414.108 411.301 454.7 377.439 508.761 373.203Z';
const MARK_TAIL = 'M415.50 687.54L259.04 760.08L337.00 606.24Z';

function BrandLogo({
  size = 28,
  withWordmark = true,
  wordmarkClassName,
  className,
}: {
  size?: number;
  withWordmark?: boolean;
  wordmarkClassName?: string;
  className?: string;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 512 512"
        role="img"
        aria-label="Embent"
        className="shrink-0"
      >
        <rect width={512} height={512} rx={112} fill="var(--primary)" />
        <g
          fill="var(--primary-foreground)"
          transform="scale(0.7598) translate(-170.35, -176.65)"
        >
          <path d={MARK_BODY} fillRule="evenodd" />
          <path d={MARK_TAIL} />
        </g>
      </svg>
      {withWordmark && (
        <span
          className={cn('font-display font-bold tracking-tight text-foreground', wordmarkClassName)}
          style={{ fontSize: size * 0.79 }}
        >
          embent
        </span>
      )}
    </span>
  );
}

export { BrandLogo };
